// extracted by mini-css-extract-plugin
export default {"wrap":"WorkLocInput_wrap__qouH2","item":"WorkLocInput_item__XrSpe"};